// 兼容接口对象与字符串选项；空内容保留为空，避免将对象作为 React 子节点渲染。
export const getFormOptionText = (option: unknown): string => {
    const content = option !== null && typeof option === 'object'
        ? (option as { content?: unknown }).content
        : option;

    return typeof content === 'string' || typeof content === 'number' ? String(content) : '';
};
